// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NavigationBeforeLogin-root-Ugcp1 {
	margin: 0;
}

.NavigationBeforeLogin-link-wRMxB {
	display: inline-block;
	padding: 3px 8px;
	text-decoration: none;
	font-size: 1.125em;
}

.NavigationBeforeLogin-link-wRMxB,
.NavigationBeforeLogin-link-wRMxB:active,
.NavigationBeforeLogin-link-wRMxB:visited {
	color: rgba(255, 255, 255, 0.6);
}

.NavigationBeforeLogin-link-wRMxB:hover {
	color: rgba(255, 255, 255, 1);
}

.NavigationBeforeLogin-spacer-RdmQ_ {
	color: rgba(255, 255, 255, 0.3);
}

.NavigationBeforeLogin-centerLink-eUZ0j {
	display: inline-block;
	font-size: 18px;
	color: var(--common-primary-white-foreground);
	margin-right: 50px;
	font-weight: 600;
}

.NavigationBeforeLogin-centerLink-eUZ0j:last-child {
	margin: 0;
}

.NavigationBeforeLogin-centerLink-eUZ0j a,
.NavigationBeforeLogin-centerLink-eUZ0j a:hover,
.NavigationBeforeLogin-centerLink-eUZ0j a:focus {
	color: var(--common-primary-white-foreground);
	text-decoration: none;
}

.NavigationBeforeLogin-dot-sZTPi {
	position: relative;
}

.NavigationBeforeLogin-dot-sZTPi::after {
	content: '';
	width: 6px;
	height: 6px;
	background: var(--common-primary-white-foreground);
	border-radius: 50%;
	position: absolute;
	top: 48%;
	right: -26px;
}

.NavigationBeforeLogin-dot-sZTPi::before {
	content: '';
	width: 57px;
	height: 1.5px;
	background: var(--common-primary-white-foreground);
	position: absolute;
	bottom: -3px;
	right: 0;
	left: 0;
	margin: 0 auto;
}

.NavigationBeforeLogin-innerLink-s6BFp a {
	color: var(--primary-foreground) !important;
	font-size: 16px;
	text-decoration: none !important;
}

.NavigationBeforeLogin-floatLeft-Smtbs {
	float: left;
}

.NavigationBeforeLogin-disPlayInline-Pmwqd {
	display: inline-block;
}

.NavigationBeforeLogin-innerLink-s6BFp {
	width: 120px;
}

.NavigationBeforeLogin-themeIconSec-aMoU4 {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	font-size: 16px;
	gap: 4px;
}

.NavigationBeforeLogin-themeIconAlignment-vmXxK {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
}

.NavigationBeforeLogin-languageFlex-scWvw {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-pack: center;
	    -ms-flex-pack: center;
	        justify-content: center;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	-webkit-column-gap: 10px;
	   -moz-column-gap: 10px;
	        column-gap: 10px;
}

.NavigationBeforeLogin-textColor-u3yZM {
	color: var(--primary-foreground);
}

.NavigationBeforeLogin-selectedThemeColor-fT8Zq {
	color: var(--secondary-bg);
}

@media screen and (max-width:1199px) {
	.NavigationBeforeLogin-newMenuDesign-XkbNw {
		margin-top: 50px;
		border-top: 1px solid var(--primary-border);
		background-color: var(--background-primary);
	}

	.NavigationBeforeLogin-mbTop-v7Egh a {
		padding-top: 13px !important;
	}
}

@media screen and (max-width: 1199px) {
	.NavigationBeforeLogin-tabViewHidden-FbVCd {
		display: none !important;
	}
}

@media screen and (max-width:1199px) and (min-width:768px) {
	.NavigationBeforeLogin-newMenuDesign-XkbNw {
		margin-top: 60px;
	}

	.NavigationBeforeLogin-mbTop-v7Egh a {
		padding-top: 8px !important;
	}
}

@media screen and (max-width:767px) {
	.NavigationBeforeLogin-newMenuDesign-XkbNw {
		margin-top: 40px;
	}

	.NavigationBeforeLogin-mbTop-v7Egh a {
		padding-top: 8px !important;
	}

}`, "",{"version":3,"sources":["webpack://./src/components/NavigationBeforeLogin/NavigationBeforeLogin.css"],"names":[],"mappings":"AAAA;CACC,SAAS;AACV;;AAEA;CACC,qBAAqB;CACrB,gBAAgB;CAChB,qBAAqB;CACrB,kBAAkB;AACnB;;AAEA;;;CAGC,+BAA+B;AAChC;;AAEA;CACC,6BAA6B;AAC9B;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,qBAAqB;CACrB,eAAe;CACf,6CAA6C;CAC7C,kBAAkB;CAClB,gBAAgB;AACjB;;AAEA;CACC,SAAS;AACV;;AAEA;;;CAGC,6CAA6C;CAC7C,qBAAqB;AACtB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,WAAW;CACX,UAAU;CACV,WAAW;CACX,kDAAkD;CAClD,kBAAkB;CAClB,kBAAkB;CAClB,QAAQ;CACR,YAAY;AACb;;AAEA;CACC,WAAW;CACX,WAAW;CACX,aAAa;CACb,kDAAkD;CAClD,kBAAkB;CAClB,YAAY;CACZ,QAAQ;CACR,OAAO;CACP,cAAc;AACf;;AAGA;CACC,2CAA2C;CAC3C,eAAe;CACf,gCAAgC;AACjC;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,eAAe;CACf,QAAQ;AACT;;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;AACpB;;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,wBAAuB;KAAvB,qBAAuB;SAAvB,uBAAuB;CACvB,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,wBAAgB;IAAhB,qBAAgB;SAAhB,gBAAgB;AACjB;;AAEA;CACC,gCAAgC;AACjC;;AAEA;CACC,0BAA0B;AAC3B;;AAGA;CACC;EACC,gBAAgB;EAChB,2CAA2C;EAC3C,2CAA2C;CAC5C;;CAEA;EACC,4BAA4B;CAC7B;AACD;;AAEA;CACC;EACC,wBAAwB;CACzB;AACD;;AAEA;CACC;EACC,gBAAgB;CACjB;;CAEA;EACC,2BAA2B;CAC5B;AACD;;AAEA;CACC;EACC,gBAAgB;CACjB;;CAEA;EACC,2BAA2B;CAC5B;;AAED","sourcesContent":[".root {\n\tmargin: 0;\n}\n\n.link {\n\tdisplay: inline-block;\n\tpadding: 3px 8px;\n\ttext-decoration: none;\n\tfont-size: 1.125em;\n}\n\n.link,\n.link:active,\n.link:visited {\n\tcolor: rgba(255, 255, 255, 0.6);\n}\n\n.link:hover {\n\tcolor: rgba(255, 255, 255, 1);\n}\n\n.spacer {\n\tcolor: rgba(255, 255, 255, 0.3);\n}\n\n.centerLink {\n\tdisplay: inline-block;\n\tfont-size: 18px;\n\tcolor: var(--common-primary-white-foreground);\n\tmargin-right: 50px;\n\tfont-weight: 600;\n}\n\n.centerLink:last-child {\n\tmargin: 0;\n}\n\n.centerLink a,\n.centerLink a:hover,\n.centerLink a:focus {\n\tcolor: var(--common-primary-white-foreground);\n\ttext-decoration: none;\n}\n\n.dot {\n\tposition: relative;\n}\n\n.dot::after {\n\tcontent: '';\n\twidth: 6px;\n\theight: 6px;\n\tbackground: var(--common-primary-white-foreground);\n\tborder-radius: 50%;\n\tposition: absolute;\n\ttop: 48%;\n\tright: -26px;\n}\n\n.dot::before {\n\tcontent: '';\n\twidth: 57px;\n\theight: 1.5px;\n\tbackground: var(--common-primary-white-foreground);\n\tposition: absolute;\n\tbottom: -3px;\n\tright: 0;\n\tleft: 0;\n\tmargin: 0 auto;\n}\n\n\n.innerLink a {\n\tcolor: var(--primary-foreground) !important;\n\tfont-size: 16px;\n\ttext-decoration: none !important;\n}\n\n.floatLeft {\n\tfloat: left;\n}\n\n.disPlayInline {\n\tdisplay: inline-block;\n}\n\n.innerLink {\n\twidth: 120px;\n}\n\n.themeIconSec {\n\tdisplay: flex;\n\talign-items: center;\n\tfont-size: 16px;\n\tgap: 4px;\n}\n\n.themeIconAlignment {\n\tdisplay: flex;\n\talign-items: center;\n}\n\n.languageFlex {\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tcolumn-gap: 10px;\n}\n\n.textColor {\n\tcolor: var(--primary-foreground);\n}\n\n.selectedThemeColor {\n\tcolor: var(--secondary-bg);\n}\n\n\n@media screen and (max-width:1199px) {\n\t.newMenuDesign {\n\t\tmargin-top: 50px;\n\t\tborder-top: 1px solid var(--primary-border);\n\t\tbackground-color: var(--background-primary);\n\t}\n\n\t.mbTop a {\n\t\tpadding-top: 13px !important;\n\t}\n}\n\n@media screen and (max-width: 1199px) {\n\t.tabViewHidden {\n\t\tdisplay: none !important;\n\t}\n}\n\n@media screen and (max-width:1199px) and (min-width:768px) {\n\t.newMenuDesign {\n\t\tmargin-top: 60px;\n\t}\n\n\t.mbTop a {\n\t\tpadding-top: 8px !important;\n\t}\n}\n\n@media screen and (max-width:767px) {\n\t.newMenuDesign {\n\t\tmargin-top: 40px;\n\t}\n\n\t.mbTop a {\n\t\tpadding-top: 8px !important;\n\t}\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `NavigationBeforeLogin-root-Ugcp1`,
	"link": `NavigationBeforeLogin-link-wRMxB`,
	"spacer": `NavigationBeforeLogin-spacer-RdmQ_`,
	"centerLink": `NavigationBeforeLogin-centerLink-eUZ0j`,
	"dot": `NavigationBeforeLogin-dot-sZTPi`,
	"innerLink": `NavigationBeforeLogin-innerLink-s6BFp`,
	"floatLeft": `NavigationBeforeLogin-floatLeft-Smtbs`,
	"disPlayInline": `NavigationBeforeLogin-disPlayInline-Pmwqd`,
	"themeIconSec": `NavigationBeforeLogin-themeIconSec-aMoU4`,
	"themeIconAlignment": `NavigationBeforeLogin-themeIconAlignment-vmXxK`,
	"languageFlex": `NavigationBeforeLogin-languageFlex-scWvw`,
	"textColor": `NavigationBeforeLogin-textColor-u3yZM`,
	"selectedThemeColor": `NavigationBeforeLogin-selectedThemeColor-fT8Zq`,
	"newMenuDesign": `NavigationBeforeLogin-newMenuDesign-XkbNw`,
	"mbTop": `NavigationBeforeLogin-mbTop-v7Egh`,
	"tabViewHidden": `NavigationBeforeLogin-tabViewHidden-FbVCd`
};
module.exports = ___CSS_LOADER_EXPORT___;
